export const replaceURL = (data) => {
  const dataString = JSON.stringify(data)
  const replacedString = dataString.replaceAll('xpblsna61diz3g580m.scprev2.de', 'bacchus-api.whitelabel-hosting.de')
  return JSON.parse(replacedString)
}